module.exports = __webpack_public_path__ + "img/fluid-wagon-shadow-1.f5411f74.png";